@if (isLoading) {
<app-loader></app-loader>
} @else {
<div class="sticky top-[72px] w-full bg-white p-4 shadow-lg" style="z-index: 15">
    <!-- Filter Line -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-4 items-center">
        <!-- Filter Buttons -->
        <div class="flex gap-2 justify-center lg:justify-start items-center">
            <button (click)="changeFilterStatus('ALL')"
                [ngClass]="filterStatus === 'ALL' ? 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600' : 'bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300'">Todas</button>
            <button (click)="changeFilterStatus('AVAILABLE')"
                [ngClass]="filterStatus === 'AVAILABLE' ? 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600' : 'bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300'">Disponibles</button>
            <button (click)="changeFilterStatus('RUNNING')"
                [ngClass]="filterStatus === 'RUNNING' ? 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600' : 'bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300'">En
                marcha</button>
            <button (click)="changeFilterStatus('MAINTENANCE')"
                [ngClass]="filterStatus === 'MAINTENANCE' ? 'bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600' : 'bg-gray-200 text-gray-800 px-4 py-2 rounded hover:bg-gray-300'">En
                mantenimiento</button>
        </div>

        <!-- Selector Input -->
        <div class="flex gap-2 justify-center items-center">
            <div>
                <nz-select class="max-w-40" label="asdf" name="selectFloor" [ngModel]="'Planta 1'" disabled>
                    @for(floor of floors; track idx; let idx = $index){
                    <nz-option nzValue="{{ floor }}" nzLabel="{{ floor }}">
                    </nz-option>
                    }
                </nz-select>
            </div>
            <div>
                <nz-select class="max-w-40" label="asdf" name="selectZone" [ngModel]="'Zona 1'" disabled>
                    @for(zone of zones; track idx; let idx = $index){
                    <nz-option nzValue="{{ zone }}" nzLabel="{{ zone }}">
                    </nz-option>
                    }
                </nz-select>
            </div>
            <div>
                <nz-select class="max-w-40" name="selectLine" [ngModel]="'Linea 1'" disabled>
                    @for(line of lines; track idx; let idx = $index){
                    <nz-option nzValue="{{ line }}" nzLabel="{{ line }}">
                    </nz-option>
                    }
                </nz-select>
            </div>
        </div>
        <!-- Search Input -->
        <div class="flex gap-2 justify-center lg:justify-end items-center">
            <nz-input-group [nzPrefix]="searchIcon" [nzSuffix]="clearSearchInput"
                class="rounded-lg border border-gray-300" style="width: 250px">
                <input onfocus="select()"
                    class="block px-4 text-[15px] font-medium py-1 pl-10 w-[275px] text-gray-900 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Máquina / Proceso / Artículo" nz-input [(ngModel)]="filterText"
                    (ngModelChange)="filterMachines()" />
            </nz-input-group>
            <ng-template #clearSearchInput>
                @if (filterText) {
                <span class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" (click)="clearFilter()"
                    nz-icon></span>
                }
            </ng-template>
            <ng-template #searchIcon>
                <span nz-icon nzType="search"></span>
            </ng-template>
        </div>
    </div>
</div>

<div class="py-5">
    <!--<h1 class="w-full text-center text-2xl font-bold py-4">Planta 1 - Zona 1 - Línea 1</h1>-->

    <div class="grid gap-4 p-4 [grid-template-columns:repeat(auto-fit,minmax(350px,350px))] items-start justify-center">
        @for(machine of machinesDashboardFiltered; track machine.id){
        <div class="w-full p-0 shadow-lg rounded-lg" [ngClass]="{
            'bg-white ': hasMachineOrderInProgress(machine.productionOrderProcesses) !== -1,
          }">
            <!-- Header -->
            <div class="bg-gray-800 rounded-t-lg p-4 flex justify-between items-center">
                <button class="bg-blue-500 text-white px-1 py-1 rounded-full hover:bg-blue-700"
                    [disabled]="!hasMachineOrdersAssigned(machine)"
                    (click)="navigateToProductionOrder(machine)">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" viewBox="0 -960 960 960"
                        fill="currentColor">
                        <path
                            d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-134 0-244.5-72T61-462q-5-9-7.5-18.5T51-500q0-10 2.5-19.5T61-538q64-118 174.5-190T480-800q134 0 244.5 72T899-538q5 9 7.5 18.5T909-500q0 10-2.5 19.5T899-462q-64 118-174.5 190T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z" />
                    </svg>
                </button>
                <h3
                    class="text-sm text-gray-200 font-bold uppercase flex-grow text-center overflow-hidden text-ellipsis">
                    {{machine.name}}</h3>
                <button class="bg-red-500 text-white px-1 py-1 rounded-full hover:bg-red-700"
                    title="Crear solicitud de mantenimiento">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M12 9v2m0 4h.01M12 5a7 7 0 110 14 7 7 0 010-14z" />
                    </svg>
                </button>
            </div>

            <!-- Mid Section -->
            <div class="grid p-4 " [ngClass]="{
                'rounded-b-lg': hasMachineOrderInProgress(machine.productionOrderProcesses) === -1
              }"
              [ngClass]="{
                'bg-blue-100': (machine.state !== machineStatesEnum.MAINTENANCE && machine.state !== machineStatesEnum.OFFLINE),
                'bg-gray-100': (machine.state === machineStatesEnum.OFFLINE),
                'bg-red-100': (machine.state === machineStatesEnum.MAINTENANCE)
              }"
              >
                <div class="row flex justify-center">
                    <span [ngClass]="{
                                'bg-status-in-progress': machine.state === machineStatesEnum.RUNNING,
                                'bg-status-finished': machine.state === machineStatesEnum.MAINTENANCE,
                                'bg-status-awaiting': machine.state === machineStatesEnum.AVAILABLE,
                                'bg-status-offline': machine.state === machineStatesEnum.OFFLINE
                              }" class="text-white text-xs px-2 py-1 rounded-lg">
                        {{machine.state}}
                    </span>
                </div>
                @if (hasMachineOrderInProgress(machine.productionOrderProcesses) !== -1) {
                <div class="row flex justify-between items-center gap-x-2 pt-2">
                    @if (hasMachineShowInScreenSensor(machine) !== -1) {
                    <div class="flex-1">
                        <div class="flex flex-col items-center">
                            <app-sensor-card
                            [sensor]="sensorsValuesPerMachine.get(machine.id)!"
                            [articleId]="getFinalProductArticleId(machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)])"
                            [size]="'sm'"
                            [cardStyle]="'background-color: #e1effe; border: 1px solid #e1effe;'"></app-sensor-card>
                        </div>
                    </div>
                    }
                    <div class="flex-1">
                        <div class="flex flex-col items-center">
                            <nz-card nzTitle="Progreso" style="background-color: rgba(0,0,0,0); border: 1px solid rgba(0,0,0,0);" class="font-bold rounded-md h-full w-full">
                                <div class="h-full w-full flex justify-center items-center">
                                    <p class="'font-bold dynamic-text-default-sm">
                                        {{ calculateProgress(
                                        machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)],
                                        machine.machineSignals
                                        ) }}%
                                    </p>
                                </div>
                            </nz-card>
                        </div>
                    </div>
                    <div class="flex-1">
                        <div class="flex flex-col items-center">
                            <div
                                class="bg-yellow-400 rounded-full w-5 h-5 flex items-center justify-center text-white font-bold">
                                {{machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].productionPauses?.length
                                || 0}}</div>
                            <div class="text-xs">Pausas</div>
                        </div>
                        <div class="flex flex-col items-center">
                            <div
                                class="bg-red-500 rounded-full w-5 h-5 flex items-center justify-center text-white font-bold">
                                {{machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].losses?.length
                                || 0}}</div>
                            <div class="text-xs">Mermas</div>
                        </div>
                    </div>
                </div>

                } @else {
                <div class="row grid-rows-2">
                    <div class="row flex justify-around space-x-2">
                        <div class="flex flex-col items-center">
                            <div
                                class="bg-yellow-400 rounded-full w-5 h-5 flex items-center justify-center text-white font-bold">
                                0</div>
                            <div class="text-xs text-center">Mantenimientos pendientes</div>
                        </div>
                        <div class="flex flex-col items-center">
                            <div
                                class="bg-red-500 rounded-full w-5 h-5 flex items-center justify-center text-white font-bold">
                                0</div>
                            <div class="text-xs text-center">Mantenimientos en curso</div>
                        </div>
                    </div>
                    <div class="row flex justify-around pt-2">
                        <div class="flex flex-col items-center">
                            <div
                                class="bg-blue-400 rounded-full w-5 h-5 flex items-center justify-center text-white font-bold">
                                {{countPausedProcessess(machine.productionOrderProcesses)}}</div>
                            <div class="text-xs text-center">Procesos pausados</div>
                        </div>
                        <div class="flex flex-col items-center">
                            <div
                                class="bg-gray-500 rounded-full w-5 h-5 flex items-center justify-center text-white font-bold">
                                {{countAwaitingProcessess(machine.productionOrderProcesses)}}</div>
                            <div class="text-xs text-center">Procesos en espera</div>
                        </div>
                    </div>
                </div>
                }

            </div>
            @if (hasMachineOrderInProgress(machine.productionOrderProcesses) !== -1) {
            <!-- Stats Section -->
            <div class="py-4 px-4">
                <div class="flex justify-between text-sm gap-2">
                    <div class="flex gap-1">
                        <p class="font-bold">
                            {{getOrderTitle(machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].productionOrder!, machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)])}}
                        </p>
                    </div>
                    <div>
                        <span [ngClass]="{
                                'bg-status-in-progress': machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].status!.id === StatusEnum.IN_PROGRESS,
                                'bg-status-paused': machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].status!.id === StatusEnum.FINISHED,
                                'bg-status-finished': machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].status!.id === StatusEnum.PAUSED,
                                'bg-status-awaiting': machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].status!.id === StatusEnum.AWAITING,
                              }" class="text-white text-xs px-2 py-1 rounded-lg">
                            {{machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].status!.name}}
                        </span>
                    </div>
                </div>
                <div class="text-sm gap-2 mt-2 w-[300px]">
                    <p class="font-bold">
                        {{machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)].productionOrder!.description}}
                    </p>
                </div>
                <div class="grid grid-cols-2 text-sm gap-4 mt-2">
                    <div class="flex gap-1 justify-start">
                        <p class="font-bold">Cant. a prod.:</p>
                        <p class="text-gray-500">
                            {{getQuantityToProduce(machine.productionOrderProcesses[hasMachineOrderInProgress(machine.productionOrderProcesses)])}}
                        </p>
                    </div>
                    <div class="flex gap-1 justify-start">
                        <span class="font-bold">T. activo: </span>
                        <p class="text-gray-500"><cd-timer #timer format="intelli" [autoStart]="false"></cd-timer></p>
                    </div>
                    <div class="flex gap-1 justify-start">
                        <p class="font-bold">Cant. t. real:</p>
                        <p class="text-gray-500">
                            {{machine.machineSignals?.quantityProduced() || 0}}
                        </p>
                    </div>
                    <div class="flex gap-1 justify-start">
                        <span class="font-bold">T.estim.:</span>
                        <p class="text-gray-500">
                            {{machine.machineSignals?.estimatedTime()}}
                       </p>
                    </div>
                </div>
            </div>
            }

        </div>
        }
    </div>
</div>
}